import React from 'react';
import { StorageService } from 'service/Storage';
import Icon from '../../../assets/logo/pro-logo.svg';
export default function SKCurrency({ size }) {
  if (StorageService.getCurrency() === 'inr') {
    return (
      <div
        style={{
          fontSize: size,
          color: 'var(--primary-color)',
          marginRight: '5px',
        }}
      >
        ₹
      </div>
    );
  }
  return (
    <img
      src={Icon}
      height={size}
      width={size}
      style={{ marginRight: '5px' }}
      alt="chillar currency"
    />
  );
}
